export default __webpack_public_path__ + "static/product_sans_regular-webfont-b07f3f484aa70d0a314f6a3c3cdaa59e.woff";